/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExportJobStatusExportParticipationsResponse,
  ExportJobStatusExportResponse,
  SpaceUserCreateResponse,
  SpaceUserIndexResponse,
  SpaceUserShowResponse,
  UserCreate,
  UserExport,
  UserGroupUserGroupUserIndexResponse,
  UserLabelCounts,
  UserLabelsLabelCountsResponse,
  UserShowResponse,
  UserUpdate,
  UserUpdateResponse,
} from '../models';
import {
    ExportJobStatusExportParticipationsResponseFromJSON,
    ExportJobStatusExportParticipationsResponseToJSON,
    ExportJobStatusExportResponseFromJSON,
    ExportJobStatusExportResponseToJSON,
    SpaceUserCreateResponseFromJSON,
    SpaceUserCreateResponseToJSON,
    SpaceUserIndexResponseFromJSON,
    SpaceUserIndexResponseToJSON,
    SpaceUserShowResponseFromJSON,
    SpaceUserShowResponseToJSON,
    UserCreateFromJSON,
    UserCreateToJSON,
    UserExportFromJSON,
    UserExportToJSON,
    UserGroupUserGroupUserIndexResponseFromJSON,
    UserGroupUserGroupUserIndexResponseToJSON,
    UserLabelCountsFromJSON,
    UserLabelCountsToJSON,
    UserLabelsLabelCountsResponseFromJSON,
    UserLabelsLabelCountsResponseToJSON,
    UserShowResponseFromJSON,
    UserShowResponseToJSON,
    UserUpdateFromJSON,
    UserUpdateToJSON,
    UserUpdateResponseFromJSON,
    UserUpdateResponseToJSON,
} from '../models';

export interface CompanySpacesUserGroupsUserGroupIdUsersGetRequest {
    userGroupId: number;
    filterState?: string;
    filterNotInUserGroupIds?: Array<number>;
    filterFulltext?: string;
    filterRole?: string;
    filterDepartment?: Array<string>;
    filterJobTitle?: Array<string>;
    filterOverdueContent?: boolean;
    filterName?: string;
    filterEmail?: string;
    filterPersonalId?: string;
    filterNote?: string;
    filterSupervisorId?: Array<number>;
    filterLastActivityBefore?: string;
    filterAssignedContentCount?: string;
    filterCompletedContentCount?: string;
    filterOverdueContentCount?: string;
}

export interface CompanySpacesUserGroupsUserGroupIdUsersIdDeleteRequest {
    userGroupId: number;
    id: string;
}

export interface CompanySpacesUserGroupsUserGroupIdUsersMeDeleteRequest {
    userGroupId: number;
}

export interface CompanySpacesUsersExportGetRequest {
    filterState?: string;
    filterNotInUserGroupIds?: Array<number>;
    filterLabelIds?: any;
    filterUserIds?: any;
    filterFulltext?: string;
    filterRole?: string;
    filterDepartment?: Array<string>;
    filterJobTitle?: Array<string>;
    filterOverdueContent?: boolean;
    filterName?: string;
    filterEmail?: string;
    filterPersonalId?: string;
    filterNote?: string;
    filterSupervisorId?: Array<number>;
    filterUserLabelIds?: any;
    filterLastActivityBefore?: string;
    filterAssignedContentCount?: string;
    filterCompletedContentCount?: string;
    filterOverdueContentCount?: string;
    filterOrganizationUnitIds?: any;
    filterIncludeDescendants?: boolean;
}

export interface CompanySpacesUsersExportPostRequest {
    body?: UserExport;
}

export interface CompanySpacesUsersGetRequest {
    filterState?: string;
    filterNotInUserGroupIds?: Array<number>;
    filterLabelIds?: any;
    filterUserIds?: any;
    filterFulltext?: string;
    filterRole?: string;
    filterDepartment?: Array<string>;
    filterJobTitle?: Array<string>;
    filterOverdueContent?: boolean;
    filterName?: string;
    filterEmail?: string;
    filterPersonalId?: string;
    filterNote?: string;
    filterSupervisorId?: Array<number>;
    filterUserLabelIds?: any;
    filterLastActivityBefore?: string;
    filterAssignedContentCount?: string;
    filterCompletedContentCount?: string;
    filterOverdueContentCount?: string;
    filterOrganizationUnitIds?: any;
    filterIncludeDescendants?: boolean;
    autocomplete?: boolean;
    paginatesPer?: number;
}

export interface CompanySpacesUsersIdDeleteRequest {
    id: string;
}

export interface CompanySpacesUsersIdGetRequest {
    id: string;
}

export interface CompanySpacesUsersLabelCountsPostRequest {
    body?: UserLabelCounts;
}

export interface CompanySpacesUsersPostRequest {
    body?: UserCreate;
}

export interface UsersIdDeleteRequest {
    id: string;
}

export interface UsersIdGetRequest {
    id: string;
}

export interface UsersIdPutRequest {
    id: string;
    body?: UserUpdate;
}

export interface UsersLogoutPostRequest {
    body?: object;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersGetRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupUserGroupUserIndexResponse>>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdUsersGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.filterState !== undefined) {
            queryParameters['filter_state'] = requestParameters.filterState;
        }

        if (requestParameters.filterNotInUserGroupIds) {
            queryParameters['filter_not_in_user_group_ids'] = requestParameters.filterNotInUserGroupIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.filterRole !== undefined) {
            queryParameters['filter_role'] = requestParameters.filterRole;
        }

        if (requestParameters.filterDepartment) {
            queryParameters['filter_department'] = requestParameters.filterDepartment.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterJobTitle) {
            queryParameters['filter_job_title'] = requestParameters.filterJobTitle.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterOverdueContent !== undefined) {
            queryParameters['filter_overdue_content'] = requestParameters.filterOverdueContent;
        }

        if (requestParameters.filterName !== undefined) {
            queryParameters['filter_name'] = requestParameters.filterName;
        }

        if (requestParameters.filterEmail !== undefined) {
            queryParameters['filter_email'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPersonalId !== undefined) {
            queryParameters['filter_personal_id'] = requestParameters.filterPersonalId;
        }

        if (requestParameters.filterNote !== undefined) {
            queryParameters['filter_note'] = requestParameters.filterNote;
        }

        if (requestParameters.filterSupervisorId) {
            queryParameters['filter_supervisor_id'] = requestParameters.filterSupervisorId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterLastActivityBefore !== undefined) {
            queryParameters['filter_last_activity_before'] = requestParameters.filterLastActivityBefore;
        }

        if (requestParameters.filterAssignedContentCount !== undefined) {
            queryParameters['filter_assigned_content_count'] = requestParameters.filterAssignedContentCount;
        }

        if (requestParameters.filterCompletedContentCount !== undefined) {
            queryParameters['filter_completed_content_count'] = requestParameters.filterCompletedContentCount;
        }

        if (requestParameters.filterOverdueContentCount !== undefined) {
            queryParameters['filter_overdue_content_count'] = requestParameters.filterOverdueContentCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/users`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupUserGroupUserIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersGet(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupUserGroupUserIndexResponse>> {
        const response = await this.companySpacesUserGroupsUserGroupIdUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersIdDeleteRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdUsersIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUserGroupsUserGroupIdUsersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/users/{id}`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersIdDelete(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesUserGroupsUserGroupIdUsersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersMeDeleteRaw(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersMeDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userGroupId === null || requestParameters.userGroupId === undefined) {
            throw new runtime.RequiredError('userGroupId','Required parameter requestParameters.userGroupId was null or undefined when calling companySpacesUserGroupsUserGroupIdUsersMeDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/user_groups/{user_group_id}/users/me`.replace(`{${"user_group_id"}}`, encodeURIComponent(String(requestParameters.userGroupId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesUserGroupsUserGroupIdUsersMeDelete(requestParameters: CompanySpacesUserGroupsUserGroupIdUsersMeDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesUserGroupsUserGroupIdUsersMeDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesUsersExportGetRaw(requestParameters: CompanySpacesUsersExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportJobStatusExportResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filterState !== undefined) {
            queryParameters['filter_state'] = requestParameters.filterState;
        }

        if (requestParameters.filterNotInUserGroupIds) {
            queryParameters['filter_not_in_user_group_ids'] = requestParameters.filterNotInUserGroupIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterLabelIds !== undefined) {
            queryParameters['filter_label_ids'] = requestParameters.filterLabelIds;
        }

        if (requestParameters.filterUserIds !== undefined) {
            queryParameters['filter_user_ids'] = requestParameters.filterUserIds;
        }

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.filterRole !== undefined) {
            queryParameters['filter_role'] = requestParameters.filterRole;
        }

        if (requestParameters.filterDepartment) {
            queryParameters['filter_department'] = requestParameters.filterDepartment.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterJobTitle) {
            queryParameters['filter_job_title'] = requestParameters.filterJobTitle.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterOverdueContent !== undefined) {
            queryParameters['filter_overdue_content'] = requestParameters.filterOverdueContent;
        }

        if (requestParameters.filterName !== undefined) {
            queryParameters['filter_name'] = requestParameters.filterName;
        }

        if (requestParameters.filterEmail !== undefined) {
            queryParameters['filter_email'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPersonalId !== undefined) {
            queryParameters['filter_personal_id'] = requestParameters.filterPersonalId;
        }

        if (requestParameters.filterNote !== undefined) {
            queryParameters['filter_note'] = requestParameters.filterNote;
        }

        if (requestParameters.filterSupervisorId) {
            queryParameters['filter_supervisor_id'] = requestParameters.filterSupervisorId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterUserLabelIds !== undefined) {
            queryParameters['filter_user_label_ids'] = requestParameters.filterUserLabelIds;
        }

        if (requestParameters.filterLastActivityBefore !== undefined) {
            queryParameters['filter_last_activity_before'] = requestParameters.filterLastActivityBefore;
        }

        if (requestParameters.filterAssignedContentCount !== undefined) {
            queryParameters['filter_assigned_content_count'] = requestParameters.filterAssignedContentCount;
        }

        if (requestParameters.filterCompletedContentCount !== undefined) {
            queryParameters['filter_completed_content_count'] = requestParameters.filterCompletedContentCount;
        }

        if (requestParameters.filterOverdueContentCount !== undefined) {
            queryParameters['filter_overdue_content_count'] = requestParameters.filterOverdueContentCount;
        }

        if (requestParameters.filterOrganizationUnitIds !== undefined) {
            queryParameters['filter_organization_unit_ids'] = requestParameters.filterOrganizationUnitIds;
        }

        if (requestParameters.filterIncludeDescendants !== undefined) {
            queryParameters['filter_include_descendants'] = requestParameters.filterIncludeDescendants;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportJobStatusExportResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersExportGet(requestParameters: CompanySpacesUsersExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportJobStatusExportResponse> {
        const response = await this.companySpacesUsersExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersExportParticipationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportJobStatusExportParticipationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/export_participations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportJobStatusExportParticipationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersExportParticipationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportJobStatusExportParticipationsResponse> {
        const response = await this.companySpacesUsersExportParticipationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersExportPostRaw(requestParameters: CompanySpacesUsersExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportJobStatusExportResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserExportToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportJobStatusExportResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersExportPost(requestParameters: CompanySpacesUsersExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportJobStatusExportResponse> {
        const response = await this.companySpacesUsersExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersGetRaw(requestParameters: CompanySpacesUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpaceUserIndexResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.filterState !== undefined) {
            queryParameters['filter_state'] = requestParameters.filterState;
        }

        if (requestParameters.filterNotInUserGroupIds) {
            queryParameters['filter_not_in_user_group_ids'] = requestParameters.filterNotInUserGroupIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterLabelIds !== undefined) {
            queryParameters['filter_label_ids'] = requestParameters.filterLabelIds;
        }

        if (requestParameters.filterUserIds !== undefined) {
            queryParameters['filter_user_ids'] = requestParameters.filterUserIds;
        }

        if (requestParameters.filterFulltext !== undefined) {
            queryParameters['filter_fulltext'] = requestParameters.filterFulltext;
        }

        if (requestParameters.filterRole !== undefined) {
            queryParameters['filter_role'] = requestParameters.filterRole;
        }

        if (requestParameters.filterDepartment) {
            queryParameters['filter_department'] = requestParameters.filterDepartment.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterJobTitle) {
            queryParameters['filter_job_title'] = requestParameters.filterJobTitle.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterOverdueContent !== undefined) {
            queryParameters['filter_overdue_content'] = requestParameters.filterOverdueContent;
        }

        if (requestParameters.filterName !== undefined) {
            queryParameters['filter_name'] = requestParameters.filterName;
        }

        if (requestParameters.filterEmail !== undefined) {
            queryParameters['filter_email'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPersonalId !== undefined) {
            queryParameters['filter_personal_id'] = requestParameters.filterPersonalId;
        }

        if (requestParameters.filterNote !== undefined) {
            queryParameters['filter_note'] = requestParameters.filterNote;
        }

        if (requestParameters.filterSupervisorId) {
            queryParameters['filter_supervisor_id'] = requestParameters.filterSupervisorId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.filterUserLabelIds !== undefined) {
            queryParameters['filter_user_label_ids'] = requestParameters.filterUserLabelIds;
        }

        if (requestParameters.filterLastActivityBefore !== undefined) {
            queryParameters['filter_last_activity_before'] = requestParameters.filterLastActivityBefore;
        }

        if (requestParameters.filterAssignedContentCount !== undefined) {
            queryParameters['filter_assigned_content_count'] = requestParameters.filterAssignedContentCount;
        }

        if (requestParameters.filterCompletedContentCount !== undefined) {
            queryParameters['filter_completed_content_count'] = requestParameters.filterCompletedContentCount;
        }

        if (requestParameters.filterOverdueContentCount !== undefined) {
            queryParameters['filter_overdue_content_count'] = requestParameters.filterOverdueContentCount;
        }

        if (requestParameters.filterOrganizationUnitIds !== undefined) {
            queryParameters['filter_organization_unit_ids'] = requestParameters.filterOrganizationUnitIds;
        }

        if (requestParameters.filterIncludeDescendants !== undefined) {
            queryParameters['filter_include_descendants'] = requestParameters.filterIncludeDescendants;
        }

        if (requestParameters.autocomplete !== undefined) {
            queryParameters['autocomplete'] = requestParameters.autocomplete;
        }

        if (requestParameters.paginatesPer !== undefined) {
            queryParameters['paginates_per'] = requestParameters.paginatesPer;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpaceUserIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesUsersGet(requestParameters: CompanySpacesUsersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpaceUserIndexResponse>> {
        const response = await this.companySpacesUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersIdDeleteRaw(requestParameters: CompanySpacesUsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesUsersIdDelete(requestParameters: CompanySpacesUsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesUsersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesUsersIdGetRaw(requestParameters: CompanySpacesUsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpaceUserShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpaceUserShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersIdGet(requestParameters: CompanySpacesUsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpaceUserShowResponse> {
        const response = await this.companySpacesUsersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersLabelCountsPostRaw(requestParameters: CompanySpacesUsersLabelCountsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserLabelsLabelCountsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users/label_counts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserLabelCountsToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLabelsLabelCountsResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersLabelCountsPost(requestParameters: CompanySpacesUsersLabelCountsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserLabelsLabelCountsResponse> {
        const response = await this.companySpacesUsersLabelCountsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersPostRaw(requestParameters: CompanySpacesUsersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpaceUserCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpaceUserCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersPost(requestParameters: CompanySpacesUsersPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpaceUserCreateResponse> {
        const response = await this.companySpacesUsersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersIdDeleteRaw(requestParameters: UsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling usersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async usersIdDelete(requestParameters: UsersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async usersIdGetRaw(requestParameters: UsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling usersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async usersIdGet(requestParameters: UsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserShowResponse> {
        const response = await this.usersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersIdPutRaw(requestParameters: UsersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling usersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async usersIdPut(requestParameters: UsersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserUpdateResponse> {
        const response = await this.usersIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async usersLogoutPostRaw(requestParameters: UsersLogoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async usersLogoutPost(requestParameters: UsersLogoutPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersLogoutPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async usersMeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserShowResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async usersMeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserShowResponse> {
        const response = await this.usersMeGetRaw(initOverrides);
        return await response.value();
    }

}
